import React from 'react';
import { useIntl } from 'react-intl';

import { BADGE_SOURCES } from '../../config/configListingBadges';
import { badgesForListing, awardsForAuthor } from '../../util/listingBadges';
import ListingBadge from '../../components/ListingBadge/ListingBadge';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

/**
 * The listing's image gallery, with the listing's badge overlaid.
 *
 * The badge is a child of this section rather than of ListingImageGallery so it does
 * not depend on the gallery library's internals - the gallery component is expected to
 * be replaced, the section wrapper is not.
 *
 * Unlike a card, this surface names the specific award ("First 100") rather than the
 * category, because there is room here for it to mean something.
 */
const SectionGallery = props => {
  const { listing, variantPrefix } = props;
  const intl = useIntl();

  const images = listing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];

  const badge = badgesForListing(listing, listing.author)[0];
  const award = badge?.source === BADGE_SOURCES.AUTHOR ? awardsForAuthor(listing.author)[0] : null;
  const labelKey = award?.labelKey || badge?.labelKey;
  const label = labelKey ? intl.formatMessage({ id: labelKey }) : null;

  return (
    <section className={css.productGallery} data-testid="carousel">
      {label ? <ListingBadge className={css.galleryBadge} label={label} /> : null}
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
      />
    </section>
  );
};

export default SectionGallery;
